<!-- COM Buscar ... ********** -->
<div class="buscar__container">
    <div class="buscar__filtroBuscar">
        <em class="fa fa-search iconPlaceholder"></em>
        <input type="text" id="buscar" class="buscar__inputBuscar input-field" id="input-buscar" (input)="buscarInformacion($event.target.value)" placeholder="Buscar..." #input>
    </div>
</div>
